import { render, staticRenderFns } from "./CreateOrganizationManually.vue?vue&type=template&id=509fb57e&scoped=true&"
import script from "./CreateOrganizationManually.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizationManually.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganizationManually.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CreateOrganizationManually.vue?vue&type=style&index=1&id=509fb57e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fb57e",
  null
  
)

export default component.exports